import { toast } from '@/hooks/use-toast';
import React from 'react';

const FacebookMessagerButton = ({ psid, pageId, customerName }: { psid: string, pageId: string, customerName: string }) => {

    const handleOpenMessenger = () => {
        // 1. m.me Universal Link - This is the most reliable way to "force" open the app to a specific user
        // It acts as a universal link on mobile (intercepted by App) and web redirect on desktop.
        const mobileAppUrl = `https://m.me`;

        // 2. Meta Business Suite (Recommended for Admins/Business context)
        const businessSuiteUrl = `https://business.facebook.com/latest/inbox/messenger/${pageId}/${psid}`;

        // Attempt to trigger the native Messenger App first

        if (customerName) {
            navigator.clipboard.writeText(customerName);
        }

        toast({
            title: "Attempt Open Reply",
            description: `Copied "${customerName}" to clipboard. Opening Messenger...`,
        });
        window.location.href = mobileAppUrl;


        // Set a timeout to check if the app opened. 
        // If the browser window is still active after 500ms, open the web version.
        setTimeout(() => {
            if (document.hasFocus()) {
                // Priority: Open Business Suite in a new tab for a better admin experience
                toast({
                    title: "Manual Reply",
                    description: `Open Facebook Messenger. (psid: ${psid}, pageId: ${pageId}) [${businessSuiteUrl}]`,
                });
                window.open(businessSuiteUrl, "_blank", "noopener,noreferrer");

            }
        }, 500);
    };

    return (
        <button
            onClick={handleOpenMessenger}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '8px 16px',
                backgroundColor: '#0084FF',
                color: 'white',
                border: 'none',
                borderRadius: '24px', // More rounded for floating button
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(0, 132, 255, 0.4)', // Enhanced shadow
                position: 'fixed',
                bottom: '24px',
                right: '24px',
                zIndex: 50,
                transition: 'transform 0.2s',
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
            <MessengerIcon />
            <span style={{ marginLeft: '8px' }}>Manual Reply</span>
        </button>
    );
};

// Simple SVG Icon for the button
const MessengerIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.477 2 2 6.145 2 11.258c0 2.908 1.462 5.503 3.746 7.218V22l3.39-1.859c.91.252 1.875.39 2.864.39 5.523 0 10-4.145 10-9.258C22 6.145 17.523 2 12 2zm1.26 12.18l-2.55-2.723-4.978 2.723 5.474-5.814 2.62 2.723 4.908-2.723-5.474 5.814z" />
    </svg>
);

export default FacebookMessagerButton;